module.exports = __webpack_public_path__ + "static/img/yixitalks.b091f246.png";